import { IsString } from 'class-validator';

export class SystemMessageRequestDto {
  @IsString()
  readonly dialogId: string;
}
